module.exports = __webpack_public_path__ + "images/emoji/mouse.ed0e8563dbe40e085e63.png";